import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";

export function LockedModule({ label, plan, includedIn = [] }) {
  return (
    <div className="max-w-xl mx-auto mt-12 rounded-md border border-border bg-card p-10 text-center" data-testid="locked-module">
      <div className="w-14 h-14 rounded-full bg-ink text-gold mx-auto flex items-center justify-center mb-5"><Lock className="w-6 h-6" strokeWidth={1.5} /></div>
      <p className="uppercase tracking-[0.2em] text-[10px] text-muted-foreground mb-2">Module not in your plan</p>
      <h1 className="font-serif text-3xl text-foreground mb-3" data-testid="locked-module-title">{label}</h1>
      <p className="text-sm text-muted-foreground mb-6">
        {plan && plan !== "none" ? <>Your <span className="capitalize font-medium text-foreground">{plan}</span> plan doesn't include this module.</> : "Choose a plan to unlock this module."}
        {includedIn.length > 0 && <> Available on <span className="capitalize font-medium text-foreground" data-testid="locked-module-plans">{includedIn.join(", ")}</span>.</>}
      </p>
      <Link to="/dashboard/billing" data-testid="locked-module-upgrade-btn" className="inline-flex items-center gap-2 bg-primary text-primary-foreground rounded-full px-6 py-3 text-sm hover:opacity-90 transition-opacity">
        Upgrade plan <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
